<template>
  <div class="results__section">
    <div class="results__wrapper">
      <div v-if="resultsExplainerText">
        <p class="p-large results__explainer-text" v-html="resultsExplainerText">{{ resultsExplainerText }}</p>
      </div>
      <div v-if="isTab2">
        <div v-if="loading">
          <Loader :loading="loading"></Loader>
        </div>
        <div v-else-if="providers.error">
          <span v-html="providers.errorMessage"></span>
        </div>
        <div v-else-if="messageType == 'error'">
          <APIErrorMsg
            :message="message"
            :messageType="messageType"
          ></APIErrorMsg>
        </div>
        <div v-else>
          <ResultsList
            :isTab2="isTab2"
            :noResultsText="noResultsText"
            :providers="providers.providers"
            :providerCount="providerCount"
            :resultsExplainerText="resultsExplainerText"
            :showNoResultsText="showNoResultsText"
            :showResultsCountText="showResultsCountText"
            :supplierCount="supplierCount"
            :suppliers="suppliers"
          ></ResultsList>
        </div>
      </div>
      <div v-else>
        <div v-if="loading">
          <Loader :loading="loading"></Loader>
        </div>
        <div v-else-if="providers.error">
          <span v-html="providers.errorMessage"></span>
        </div>
        <div v-else-if="messageType == 'error'">
          <APIErrorMsg
            :message="message"
            :messageType="messageType"
          ></APIErrorMsg>
        </div>
        <div v-else>
          <ResultsList
            :isTab2="isTab2"
            :noResultsText="noResultsText"
            :providerCount="providerCount"
            :providers="providers.providers"
            :resultsExplainerText="resultsExplainerText"
            :resultsToShow="20"
            :showNoResultsText="showNoResultsText"
            :showResultsCountText="showResultsCountText"
          ></ResultsList>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import APIErrorMsg from "./ApiErrorMessage.vue";
import LoaderVue from "./Loader.vue";
import ResultsList from "./ResultsList.vue";
import Vue from "vue";

export default Vue.component("ResultsSection", {
  props: {
    APICall: Function,
    isTab2: Boolean,
    loading: Boolean,
    message: String,
    messageType: String,
    noResultsText: String,
    pagination: Array,
    paginationShowNext: Boolean,
    providers: Object,
    providerCount: Number,    
    resultsExplainerText: String,
    resultsCurrentPage: Number,
    resultsTotalPages: Number,
    showNoResultsText: Boolean,
    showResultsCountText: Boolean,
    suppliers: Array,
    supplierCount: Number,
  },
  components: {
    APIErrorMsg,
    Loader: LoaderVue,
    ResultsList,
  },
});
</script>
